/* @flow */

import {useGetLimitsByType} from '../../../../limits';

export const useGetPowerAiMonthlyUsage = (): {
    monthlyUsage: ?{
        limit: number,
        remaining: number,
    },
    isLoading: boolean,
    error?: boolean,
} => {
    const {isLoading, limits, errorMessage} = useGetLimitsByType('AI_TOKENS');

    let monthlyUsage;
    if (
        limits &&
        typeof limits.currentUsage === 'number' &&
        typeof limits.currentPlanLimit === 'number'
    ) {
        // currentUsage type could be undefined, so need to wrap in check
        monthlyUsage = {
            remaining: limits.currentPlanLimit - limits.currentUsage,
            limit: limits.currentPlanLimit,
        };
    }

    return {
        monthlyUsage,
        isLoading,
        error: Boolean(errorMessage || (!isLoading && !monthlyUsage)),
    };
};
